import { PhonePasswordScreen } from './PhonePasswordScreen';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { HOME } from '../../constants/routes';
import { PhoneForgotPasswordScreen } from './phoneForgotPasswordScreen';
import { PhonePasswordCreate } from './phonePasswordCreate';
import { PhoneNumberVerify } from './phoneNumberVerify';

export const PhoneLoginRooter = () => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  if (user?._id) {
    navigate(HOME);
  }

  return (
    <Routes>
      <Route path="/" element={<PhonePasswordScreen />} />
      <Route path="forgot" element={<PhoneForgotPasswordScreen />} />
      <Route path="verify" element={<PhoneNumberVerify />} />
      <Route path="create" element={<PhonePasswordCreate />} />
    </Routes>
  );
};